module.exports = __webpack_public_path__ + "img/25.2b35020c.jpg";